module.exports = __webpack_public_path__ + "static/media/TT Commons Trial Regular.8b83d4ef.otf";